import React from 'react';
import Brand from '../../Brand';

import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@mui/system';
import AppConfig from '@/app/constants/AppConfig';

const useStyles = makeStyles(() => {
    return {
        loginFooter: {
            padding: '10px 0px',
            borderTop: '1px solid #ecf0f1',
            fontSize: '14px',
            fontWeight: 'normal',
            margin: 0,
            textAlign: 'right',
        },
    };
});

const LoginFormFooter = () => {
    const classes = useStyles();
    const brandingTheme =
        AppConfig && AppConfig.instance.getConfigKey('th') === 'branding';
    const userBranding =
        brandingTheme &&
        AppConfig.instance.getConfigKey(AppConfig.PROPERTY_BRANDING);
    const showXTrackBrand = userBranding
        ? userBranding.xtrackBrandOnLoginPage
        : true;

    return (
        <footer className={classes.loginFooter}>
            {showXTrackBrand ? <Brand /> : <Box height={20} />}
        </footer>
    );
};

export default LoginFormFooter;
